import React from 'react';
import { useEffect, useState } from 'react';
import './ThemeToggle.css';

const ThemeToggle = () => {
	const [isDark, setIsDark] = useState(false);

	useEffect(() => {
		// Check for saved user preference, first in localStorage, then system preference
		const savedTheme = localStorage.getItem('theme');
		if (savedTheme) {
			setIsDark(savedTheme === 'dark');
		} else {
			setIsDark(
				window.matchMedia('(prefers-color-scheme: dark)').matches
			);
		}
	}, []);

	useEffect(() => {
		// Update data-theme attribute and localStorage when theme changes
		document.documentElement.setAttribute(
			'data-theme',
			isDark ? 'dark' : 'light'
		);
		localStorage.setItem('theme', isDark ? 'dark' : 'light');
	}, [isDark]);

	return (
		<label className='switch'>
			<input
				type='checkbox'
				checked={isDark}
				onChange={() => setIsDark(!isDark)}
			/>
			<span className='slider round'></span>
		</label>
	);
};

export default ThemeToggle;
